export enum RecurrenceType {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export interface DailyRecurrenceDto {
  interval?: number;
  excludedDays?: number[];
}

export interface WeeklyRecurrenceDto {
  interval: number;
  days: number[];
}

export interface MonthlyRecurrenceDto {
  interval: number;
  dayOfMonth?: number;
}

export interface YearlyRecurrenceDto {
  month: number;
  dayOfMonth: number;
}

export interface EventRecurrenceDto {
  type: RecurrenceType;
  daily?: DailyRecurrenceDto;
  weekly?: WeeklyRecurrenceDto;
  monthly?: MonthlyRecurrenceDto;
  yearly?: YearlyRecurrenceDto;
}

export enum HowLongMode {
  Always = 0,
  UntilDate = 1,
  ForXTimes = 2,
}

export interface HowLongDto {
  mode: HowLongMode;
  untilDate?: string;
  times?: number;
}

export enum AttendeeStatus {
  Accepted = 0,
  Declined = 1,
  Tentative = 2,
  NeedsAction = 3,
}

export interface EventAttendeeDto {
  id?: string;
  userId: string;
  isOrganizer: boolean;
  isRequired: boolean;
  status?: AttendeeStatus;
  declineReason?: string;
  eventRoleId?: string;
  eventRoleName?: string;
}

export type EventKind = 'Local' | 'Global';
export type EventScope = 'LocalOnly' | 'GlobalAllChildren' | 'GlobalSelectedChildren';

export interface EventPriestDto {
  id: string;
  displayName: string;
  email?: string;
  phoneNumber?: string;
  userId?: string;
  isActive: boolean;
}

export interface EventDto {
  id: string;
  entityId: string;
  sourceEntityId?: string;
  entityEventId?: string;
  title: string;
  description: string;
  eventPlace: string;
  dateFrom: string;
  dateTo: string;
  allDay: boolean;
  visibleForGuests: boolean;
  email?: string;
  pointsPerEvent: number;
  optionalPointsPerEvent?: number | null;
  absencePenaltyPoints?: number | null;
  qrConfirmationWindowMinutes: number;
  attendeeReminderMinutesBefore?: number | null;
  recurrence?: EventRecurrenceDto;
  recurrenceEndDate?: string | null;
  howLong?: HowLongDto | null;
  categoryIds: string[];
  attendees: EventAttendeeDto[];
  kind?: EventKind;
  scope?: EventScope;
  isGlobal?: boolean;
  isGlobalSource?: boolean;
  targetEntityIds?: string[];
  originalOccurrenceDate?: string | null;
  color?: string;
  priests?: EventPriestDto[];
  priestIds?: string[];
  seriesId?: string;
  originalDateFrom?: string;
}
export interface CreateEventDto extends Omit<EventDto, 'id' | 'entityId' | 'sourceEntityId' | 'entityEventId' | 'originalOccurrenceDate' | 'isGlobal' | 'isGlobalSource' | 'seriesId' | 'originalDateFrom' | 'howLong'> {
  howLong?: HowLongDto;
}
export interface UpdateEventDto extends Omit<EventDto, 'entityId' | 'howLong'> {
  originalDateFrom: string;
  howLong?: HowLongDto;
  selectedWeekdays?: number[];
}

export const UpdateEvent = {
    Single: 0,
    Future: 1,
    Series: 2,
    SelectedWeekdays: 'SelectedWeekdays',
} as const;

export type UpdateEvent = typeof UpdateEvent[keyof typeof UpdateEvent];

export type SimpleEvent = {
    id: string;
    occurenceId: string;
    title: string;
    allDay: boolean;
    start: Date;
    end: Date;
    desc: string;
    attendees: EventAttendeeDto[];
    categoryIds: string[];
    color?: string;
};
